import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/401',
    name: 'Error401',
    component: () => import('@/views/error/401/index.vue'),
    meta: { title: '401' }
  },
  {
    path: '/403',
    name: 'Error403',
    component: () => import('@/views/error/403/index.vue'),
    meta: { title: '403' }
  },
  {
    path: '/500',
    name: 'Error500',
    component: () => import('@/views/error/500/index.vue'),
    meta: { title: '500' }
  },
  {
    path: '/404',
    name: 'Error404',
    component: () => import('@/views/error/404/index.vue'),
    meta: { title: '404' }
  },
  { path: '/', redirect: '/lifecycle/overview' },
  {
    path: '/',
    component: Layout,
    children: [
      // ── 项目生命周期 ──
      {
        path: 'lifecycle/overview',
        name: 'LifecycleOverview',
        component: () => import('@/views/lifecycle/overview/index.vue'),
        meta: { title: '项目总览', menu: '/lifecycle', icon: '<rect x="1.5" y="1.5" width="5.5" height="5.5" rx="1" stroke="currentColor"/><rect x="9" y="1.5" width="5.5" height="5.5" rx="1" stroke="currentColor"/><rect x="1.5" y="9" width="5.5" height="5.5" rx="1" stroke="currentColor"/><rect x="9" y="9" width="5.5" height="5.5" rx="1" stroke="currentColor"/>' }
      },
      {
        path: 'lifecycle/reserve',
        name: 'LifecycleReserve',
        component: () => import('@/views/lifecycle/reserve/index.vue'),
        meta: { title: '项目储备', menu: '/lifecycle', icon: '<rect x="2" y="5.5" width="12" height="8.5" rx="1" stroke="currentColor"/><path d="M2 5.5l1.5-3.5h9L14 5.5" stroke="currentColor"/><path d="M6 9h4" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'lifecycle/pending',
        name: 'LifecyclePending',
        component: () => import('@/views/lifecycle/pending/index.vue'),
        meta: { title: '待上会项目', menu: '/lifecycle', icon: '<circle cx="8" cy="8" r="6" stroke="currentColor"/><path d="M8 5v3.2l2.2 1.4" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'lifecycle/review',
        name: 'LifecycleReview',
        component: () => import('@/views/lifecycle/review/index.vue'),
        meta: { title: '项目审核', menu: '/lifecycle', icon: '<circle cx="7" cy="7" r="4.5" stroke="currentColor"/><path d="M10.5 10.5l3 3" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'lifecycle/approval',
        name: 'LifecycleApproval',
        component: () => import('@/views/lifecycle/approval/index.vue'),
        meta: { title: '项目立项', menu: '/lifecycle', icon: '<rect x="3" y="1.5" width="10" height="13" rx="1" stroke="currentColor"/><path d="M6 6h4M6 8.5h2" stroke="currentColor" stroke-linecap="round"/><path d="M8.5 11l1.5 1.5 2-2.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },
      {
        path: 'lifecycle/implement',
        name: 'LifecycleImplementation',
        component: () => import('@/views/lifecycle/implementation/index.vue'),
        meta: { title: '项目实施', menu: '/lifecycle', icon: '<path d="M13 3a3.5 3.5 0 0 0-4.5 4.5L3 13a1 1 0 0 0 1.5 1.5l5.5-5.5A3.5 3.5 0 0 0 13 3z" stroke="currentColor"/><path d="M11 5l1 1" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'lifecycle/acceptance',
        name: 'LifecycleAcceptance',
        component: () => import('@/views/lifecycle/acceptance/index.vue'),
        meta: { title: '项目验收', menu: '/lifecycle', icon: '<circle cx="8" cy="8" r="6" stroke="currentColor"/><path d="M5.5 8l2 2 3-3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },
      {
        path: 'lifecycle/operation',
        name: 'LifecycleOperation',
        component: () => import('@/views/lifecycle/operation/index.vue'),
        meta: { title: '项目投运', menu: '/lifecycle', icon: '<path d="M10 2L5 9h4l-1 5 6-7H10l1-5z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },

      // ── 运营管理 ──
      { path: 'operation', redirect: '/operation/overview', meta: { hidden: true } },
      {
        path: 'operation/user-profile',
        name: 'OperationUserProfile',
        component: () => import('@/views/operation/user-profile/index.vue'),
        meta: { title: '用户画像', menu: '/operation', icon: '<circle cx="8" cy="5.5" r="3" stroke="currentColor"/><path d="M2.5 14c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'operation/order',
        name: 'OperationOrder',
        component: () => import('@/views/operation/order/index.vue'),
        meta: { title: '订单查询', menu: '/operation', icon: '<rect x="2.5" y="1.5" width="11" height="13" rx="1" stroke="currentColor"/><path d="M5.5 5.5h5M5.5 8h5M5.5 10.5h3" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'operation/pricing',
        name: 'OperationPricing',
        component: () => import('@/views/operation/pricing/index.vue'),
        meta: { title: '定价策略', menu: '/operation', icon: '<path d="M9 2H14v5l-6.5 6.5a1.5 1.5 0 0 1-2 0l-3-3a1.5 1.5 0 0 1 0-2L9 2z" stroke="currentColor"/><circle cx="11.5" cy="4.5" r="1" fill="currentColor" stroke="none"/>' }
      },
      // 定价策略子页（不显示在菜单）
      {
        path: 'operation/pricing/service-fee',
        name: 'OperationServiceFeePolicyForm',
        component: () => import('@/views/operation/pricing/service-fee-form.vue'),
        meta: { title: '服务费策略', menu: '/operation', activeMenu: '/operation/pricing', hidden: true }
      },
      {
        path: 'operation/pricing/electricity',
        name: 'OperationElectricityPolicyForm',
        component: () => import('@/views/operation/pricing/electricity-form.vue'),
        meta: { title: '电价策略', menu: '/operation', activeMenu: '/operation/pricing', hidden: true }
      },
      // 运营活动子组（subMenu 标记归属）
      {
        path: 'operation/activity',
        name: 'OperationActivity',
        component: () => import('@/views/operation/activity/index.vue'),
        meta: { title: '活动管理', menu: '/operation', subMenu: '/operation/activity-group', icon: '<rect x="2" y="7" width="12" height="7" rx="1" stroke="currentColor"/><path d="M2 7h12v-2H2z" stroke="currentColor"/><path d="M8 5V14M5.5 5A2.5 2.5 0 0 1 8 2.5M10.5 5A2.5 2.5 0 0 0 8 2.5" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'operation/activity/create',
        name: 'OperationActivityCreate',
        component: () => import('@/views/operation/activity/create.vue'),
        meta: { title: '新增运营活动', menu: '/operation', activeMenu: '/operation/activity', hidden: true }
      },
      {
        path: 'operation/coupon-template',
        name: 'OperationCouponTemplate',
        component: () => import('@/views/operation/coupon-template/index.vue'),
        meta: { title: '优惠券模板', menu: '/operation', subMenu: '/operation/activity-group', icon: '<rect x="1.5" y="4" width="13" height="8" rx="1" stroke="currentColor"/><circle cx="1.5" cy="8" r="1.5" fill="#C9FCD1" stroke="currentColor"/><circle cx="14.5" cy="8" r="1.5" fill="#C9FCD1" stroke="currentColor"/><path d="M6 8h.1M8 8h.1M10 8h.1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' }
      },
      {
        path: 'operation/coupon-template/create',
        name: 'OperationCouponTemplateCreate',
        component: () => import('@/views/operation/coupon-template/create.vue'),
        meta: { title: '新增优惠券模板', menu: '/operation', activeMenu: '/operation/coupon-template', hidden: true }
      },
      {
        path: 'operation/evaluation',
        name: 'OperationEvaluation',
        component: () => import('@/views/operation/evaluation/index.vue'),
        meta: { title: '活动后评估', menu: '/operation', subMenu: '/operation/activity-group', icon: '<path d="M3 12V8M7 12V5M11 12V7M15 12V3" stroke="currentColor" stroke-linecap="round"/><path d="M1 13h14" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'operation/evaluation/detail',
        name: 'OperationEvaluationDetail',
        component: () => import('@/views/operation/evaluation/index.vue'),
        meta: { title: '活动后评估详情', menu: '/operation', activeMenu: '/operation/evaluation', hidden: true }
      },

      // ── 运维管理 ──
      { path: 'maintenance', redirect: '/maintenance/device', meta: { hidden: true } },
      {
        path: 'operation/station',
        name: 'MaintenanceStation',
        component: () => import('@/views/operation/station/index.vue'),
        meta: { title: '站点管理', menu: '/maintenance', icon: '<path d="M8 1.5A4.5 4.5 0 0 1 12.5 6c0 3-4.5 8.5-4.5 8.5S3.5 9 3.5 6A4.5 4.5 0 0 1 8 1.5z" stroke="currentColor"/><circle cx="8" cy="6" r="1.5" stroke="currentColor"/>' }
      },
      {
        path: 'maintenance/device',
        name: 'MaintenanceDevice',
        component: () => import('@/views/maintenance/device/index.vue'),
        meta: { title: '设备台账', menu: '/maintenance', icon: '<rect x="2" y="3" width="12" height="13" rx="1" stroke="currentColor"/><path d="M5 7h6M5 9.5h6M5 12h4" stroke="currentColor" stroke-linecap="round"/><rect x="10" y="1.5" width="4" height="3" rx="1" stroke="currentColor"/>' }
      },
      {
        path: 'maintenance/monitor',
        name: 'MaintenanceMonitor',
        component: () => import('@/views/maintenance/monitor/index.vue'),
        meta: { title: '状态监控', menu: '/maintenance', icon: '<rect x="1.5" y="2.5" width="13" height="9" rx="1" stroke="currentColor"/><path d="M5.5 14.5h5M8 11.5v3" stroke="currentColor" stroke-linecap="round"/><circle cx="8" cy="7" r="2" stroke="currentColor"/>' }
      },
      {
        path: 'maintenance/alarm',
        name: 'MaintenanceAlarm',
        component: () => import('@/views/maintenance/alarm/index.vue'),
        meta: { title: '告警记录', menu: '/maintenance', icon: '<path d="M8 2a4 4 0 0 0-4 4v3l-1.5 2.5h11L12 9V6a4 4 0 0 0-4-4z" stroke="currentColor"/><path d="M6.5 11.5a1.5 1.5 0 0 0 3 0" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'maintenance/api-log',
        name: 'MaintenanceApiLog',
        component: () => import('@/views/maintenance/api-log/index.vue'),
        meta: { title: '接口日志', menu: '/maintenance', icon: '<rect x="1.5" y="2.5" width="13" height="11" rx="1" stroke="currentColor"/><path d="M4.5 6.5l2 2-2 2M8 10.5h3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },
      {
        path: 'maintenance/record',
        name: 'MaintenanceRecord',
        component: () => import('@/views/maintenance/record/index.vue'),
        meta: { title: '运维记录', menu: '/maintenance', icon: '<rect x="3" y="3" width="10" height="11" rx="1" stroke="currentColor"/><path d="M6 3.5h4M5.5 7.5l2 2 3-3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },

      // ── 结算管理 ──
      { path: 'settlement', redirect: '/settlement/income', meta: { hidden: true } },
      {
        path: 'settlement/order-fee',
        name: 'SettlementOrderFee',
        component: () => import('@/views/settlement/order-fee/index.vue'),
        meta: { title: '订单费用明细', menu: '/settlement', icon: '<path d="M3 1.5h10v13l-2-1.5-1.5 1.5L8 13l-1.5 1.5L5 13l-2 1.5z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 5.5h4M6 8h4M6 10.5h2" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'settlement/income',
        name: 'SettlementIncome',
        component: () => import('@/views/settlement/income/index.vue'),
        meta: { title: '收入统计', menu: '/settlement', icon: '<path d="M2 12l4-4 3 3 5-6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5 5h4v4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },
      {
        path: 'settlement/detail',
        name: 'SettlementDetail',
        component: () => import('@/views/settlement/detail/index.vue'),
        meta: { title: '结算明细', menu: '/settlement', icon: '<rect x="3" y="1.5" width="10" height="13" rx="1" stroke="currentColor"/><path d="M6 5.5h4M6 8h4" stroke="currentColor" stroke-linecap="round"/><path d="M6.5 11l1.5 1.5 2.5-3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' }
      },
      {
        path: 'settlement/exception',
        name: 'SettlementException',
        component: () => import('@/views/settlement/exception/index.vue'),
        meta: { title: '异常记录', menu: '/settlement', icon: '<path d="M8 2L14.5 13H1.5L8 2z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 6.5v3" stroke="currentColor" stroke-linecap="round"/><circle cx="8" cy="11" r="0.8" fill="currentColor" stroke="none"/>' }
      },
      {
        path: 'settlement/prepay-reconciliation',
        name: 'SettlementPrepayReconciliation',
        component: () => import('@/views/settlement/prepay-exception/index.vue'),
        props: { pageMode: 'reconciliation' },
        meta: {
          title: '预付订单对账', menu: '/settlement',
          // readonly: 只查看/对账，无操作按钮；页面据此隐藏结算/退款/重试
          prepayReadOnly: true,
          icon: '<rect x="2" y="2" width="12" height="12" rx="1" stroke="currentColor"/><path d="M2 6h12M6 6v8" stroke="currentColor"/><path d="M8 9h4M8 11.5h3" stroke="currentColor" stroke-linecap="round"/>'
        }
      },
      {
        path: 'settlement/prepay-exception',
        name: 'SettlementPrepayException',
        component: () => import('@/views/settlement/prepay-exception/index.vue'),
        props: { pageMode: 'exception' },
        meta: {
          title: '预付异常处理', menu: '/settlement',
          // exception: 默认只显示需要人工介入的订单(卡死/离线过久/manual 补偿)
          prepayOnlyManualDefault: true,
          icon: '<rect x="2" y="3.5" width="12" height="9" rx="1" stroke="currentColor"/><path d="M2 6.5h12" stroke="currentColor"/><path d="M5 9.5h3" stroke="currentColor" stroke-linecap="round"/><circle cx="11.5" cy="10" r="2.5" fill="#FFF" stroke="currentColor"/><path d="M11.5 8.8v1.3l.9.6" stroke="currentColor" stroke-linecap="round"/>'
        }
      },

      // ── 系统管理 ──
      { path: 'system', redirect: '/system/user', meta: { hidden: true } },
      {
        path: 'system/user',
        name: 'SystemUser',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '用户中心', menu: '/system', icon: '<circle cx="8" cy="6" r="3.5" stroke="currentColor"/><path d="M1.5 15c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5" stroke="currentColor" stroke-linecap="round"/>' }
      },
      {
        path: 'system/permission',
        name: 'SystemPermission',
        component: () => import('@/views/system/permission/index.vue'),
        meta: { title: '权限配置', menu: '/system', icon: '<rect x="3" y="8" width="10" height="7" rx="1" stroke="currentColor"/><path d="M5 8V6a3 3 0 016 0v2" stroke="currentColor" stroke-linecap="round"/><circle cx="8" cy="11.5" r="1" fill="currentColor" stroke="none"/>' }
      },
      {
        path: 'system/operation-log',
        name: 'SystemOperationLog',
        component: () => import('@/views/system/operation-log/index.vue'),
        meta: { title: '操作日志', menu: '/system', icon: '<rect x="2" y="2.5" width="12" height="13" rx="1" stroke="currentColor"/><path d="M5 6h6M5 8.5h6M5 11h4" stroke="currentColor" stroke-linecap="round"/>' }
      }
    ]
  },
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
